/**
 * Query to fetch all available typologies
 */
const allTypologiesQuery = `
query GetAllTypologies {
  marketplace_typologies(first: 1000, order: [name_ASC]) {
    edges {
      node {
        objectId
        name
        b2b
        b2c
        icon {
          url
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default allTypologiesQuery;
